// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"7684b35b","12":"3c73ca53","52":"349f2262","168":"ed124ca0","210":"eed7d444","416":"843d74a7","464":"b46e7f5a","477":"6e56c808","671":"e564f982","696":"6f326530","706":"7555dd42","727":"bd4cdb39","824":"d751f0ae","828":"9768bbf4","888":"45413662","984":"2341fe56"}[chunkId] + ".chunk.js";
};